var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getGraphEdges, getGraphNodes } from "../../../serverApi/GraphRequests";
import { GraphDataModel } from "../model/GraphDataModel";
export class GraphController {
    constructor(dataModel) {
        this.dataModel = dataModel;
    }
    loadGraphData() {
        return __awaiter(this, void 0, void 0, function* () {
            const [nodesPromise, edgesPromise] = yield Promise.allSettled([
                getGraphNodes(),
                getGraphEdges(),
            ]);
            let rawNodes = [];
            let rawEdges = [];
            if (nodesPromise.status === "fulfilled" &&
                edgesPromise.status === "fulfilled") {
                rawNodes = nodesPromise.value.nodes;
                rawEdges = edgesPromise.value.edges;
            }
            else {
                console.error("Failed to load graph data.");
            }
            this.dataModel.setEntitiesAndEdgesWithIndexes(rawNodes, rawEdges);
        });
    }
    getModel() {
        return this.dataModel;
    }
}
const graphDataModel = new GraphDataModel();
export const graphController = new GraphController(graphDataModel);
export const graphQueries = graphDataModel;
